// old definition from tysy - not a real query being used
import type { ExternalCollaboratorEntitlementQuery } from './__types__/ExternalCollaboratorEntitlementQuery.ts';

// new definition based on generated relay types
type ExternalCollaboratorEntitlementData = {
	readonly entitlements:
		| {
				readonly externalCollaborator: {
					readonly isEntitled: boolean;
				};
		  }
		| null
		| undefined;
};

export const getExternalCollaboratorEntitlementFromQuery = (
	queryData?: ExternalCollaboratorEntitlementQuery | ExternalCollaboratorEntitlementData,
): boolean | undefined => {
	return queryData?.entitlements?.externalCollaborator.isEntitled;
};
